// extracted by mini-css-extract-plugin
export default {"main":"style_main__FDR5f","overlay":"style_overlay__5O4U8","content":"style_content__uMQya"};